import * as React from 'react';
import Table from "../../Table";
import {useCallback, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {getClients} from "../../../api";
import {Client} from "../../../types";
import dateFormat from "dateformat";

var format = require('date-format');


const SearchClients: React.FunctionComponent = () => {

    const [loading, setLoading] = useState(false);
    const [clients, setClients] = useState<Client[]>();
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [clientId, setClientId] = useState("");
    const [disabled, setDisabled] = useState("false");
    const [doLoad, setDoLoad] = useState(true);

    const load = useCallback(() => {

        if (doLoad) {
            setDoLoad(false);
            setLoading(true)
            getClients(clientId, firstName, lastName, email, disabled, "")
                .then((c) => {
                    setClients(c);
                })
                .catch((e) => {
                    console.log(e);
                }).finally(() => {
                setLoading(false);
            });
        }
    }, [clientId, firstName, lastName, email, disabled, doLoad]);

    useEffect(() => {
        load();
    }, [load]);

    return (<>

        <div className={"row"}>
            <div className={"col-lg-12 mb-3 "}>
                <h2>Clients</h2>
            </div>
            <div className={"col-lg-12 mb-3 "}>
                <Link to={"clients/add"}>
                    <button type={"button"} className={"btn btn-primary"}>Add Client</button>
                </Link>
            </div>
        </div>
        <form onSubmit={(e) => {
            e.preventDefault();
            setDoLoad(true);
        }}>
            <div className={"row"}>
                <div className={"col-lg-12 mb-3 "}>

                    <div className="form-row align-items-center">
                        <div className="col-sm-1 my-1">
                            <label className="sr-only" htmlFor="inlineFormInputName">ID</label>
                            <input type="text" className="form-control" id="inlineFormInputName"
                                   placeholder={"ID"} autoComplete={"new-password"}
                                   value={clientId} onChange={(e) => setClientId(e.target.value)}/>
                        </div>
                        <div className="col-sm-2 my-1">
                            <label className="sr-only" htmlFor="inlineFormInputName">First Name</label>
                            <input type="text" className="form-control" id="inlineFormInputName"
                                   placeholder={"First Name"} autoComplete={"new-password"}
                                   value={firstName} onChange={(e) => setFirstName(e.target.value)}/>
                        </div>
                        <div className="col-sm-2 my-1">
                            <label className="sr-only" htmlFor="inlineFormInputName">Last Name</label>
                            <input type="text" className="form-control" id="inlineFormInputName"
                                   placeholder={"Last Name"} autoComplete={"new-password"}
                                   value={lastName} onChange={(e) => setLastName(e.target.value)}/>
                        </div>
                        <div className="col-sm-2 my-1">
                            <label className="sr-only" htmlFor="inlineFormInputName">Email</label>
                            <input type="text" className="form-control" id="inlineFormInputName" placeholder={"Email"}
                                   autoComplete={"new-password"}
                                   value={email} onChange={(e) => setEmail(e.target.value)}/>
                        </div>
                        <div className="col-sm-1 my-1">
                            <label className="sr-only" htmlFor="inlineFormInputName">Disabled</label>
                            <select id="inputState" className="form-control" value={disabled}
                                    onChange={(e) => setDisabled(e.target.value)}>
                                <option value={"false"}>Active</option>
                                <option value={"true"}>Disabled</option>
                            </select>
                        </div>
                        <div className="col-auto my-1">
                            <button type="submit" className="btn btn-primary"
                            >Search
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </form>
        <div className={"row"}>
            <div hidden={!loading} className={"col-lg-12 mt-3 text-center"}>
                ...Loading clients...
            </div>
            <div hidden={loading} className={"col-lg-12 mb-3 "}>
                <Table headers={["ID", "First Name", "Last Name", "Email", "SSN", "Assessment Date"]}
                       defaultPaginationSize={10}>
                    {
                        clients?.map((c) => (
                            <tr key={c.uuid}>
                                <td>
                                    <Link to={"/m/clients/view/" + c.uuid}>
                                        {c.id}
                                    </Link>
                                </td>
                                <td>
                                    <Link to={"/m/clients/view/" + c.uuid}>
                                        {c.firstName}
                                    </Link>
                                </td>
                                <td>
                                    <Link to={"/m/clients/view/" + c.uuid}>
                                        {c.lastName}
                                    </Link>
                                </td>
                                <td>{c.email}</td>
                                <td>{c.socialsecurityNumber}</td>
                                <td>{(c.dateTimeofAssessment !== undefined) ?
                                    dateFormat(format.parse("yyyy-MM-ddThh:mm:ss", c.dateTimeofAssessment), "yyyy/mm/dd, h:MM:ss TT")
                                    : ""
                                }</td>
                                <td>


                                </td>
                            </tr>
                        ))
                    }
                </Table>
            </div>
        </div>

    </>);
};

export default SearchClients;